module.exports = __webpack_public_path__ + "img/security.d77b64aa.webp";